var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_vm._l((_vm.data),function(item,i){return [_c('EventModule',{key:((item.type) + "-" + i),attrs:{"itemInfo":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }